module.exports = __webpack_public_path__ + "img/notepad-info.b80a9072.svg";